
<script>
export default {
  name: 'ToolsFeatureButton',
  components: {},
  mounted() {},
  data() {
    return {
      elmnt: null,
      /**
       * biến lưu tọa đọ của button chat
       */
      pos1: 0,
      pos2: 0,
      pos3: 0,
      pos4: 0,
      isCloseButton: false,
      /**
       * Biến xác định đang trong kéo thả
       */
      isDragging: false,
      isHovered: false,
      /**
       * Biến xác định vị trí bắt đầu kéo thả
       */
      startPosition: {x: 0, y: 0},
      /**
       * Biến điểm đến
       */
      position: {x: 0, y: 0},

      /**
       * biến lưu để hủy mouseup
       */
      isMouseUpOnQuickChat: false,

      /**
       * Biến lưu giá trị vị trí của quick chat
       */
      positionTransfrom: {top: 44.6, right: 0, left: 'unset', bottom: 'unset'},
    };
  },
  methods: {
    /**
     * Hàm thực hiện xử lý kéo thả lấy ra vị trí của chuột
     * vcdoan 10.01.2023
     */
    dragMouseDown(e) {
      try {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor this.position at startup:
        this.pos3 = e.clientX;
        this.pos4 = e.clientY;
        document.onmouseup = this.closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = this.elementDrag;
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Hàm thực hiện xử lý di chuyển button chat khi kéo thả chuột
     * vcdoan 10.01.2023
     */
    elementDrag(e) {
      try {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        this.pos1 = this.pos3 - e.clientX;
        this.pos2 = this.pos4 - e.clientY;
        this.pos3 = e.clientX;
        this.pos4 = e.clientY;
        // set the element's new position:
        this.elmnt.style.top = this.elmnt.offsetTop - this.pos2 + 'px';
        this.elmnt.style.left = this.elmnt.offsetLeft - this.pos1 + 'px';
        document.getElementById('livechat-button').classList.add('dragging');
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Hàm xử lý ngừng sự kiện kéo thả chuột
     * vcdoan 10.01.2023
     */
    closeDragElement() {
      try {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
        document.getElementById('livechat-button').classList.remove('dragging');
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Hàm xử lý chọn element để di chuyển
     * vcdoan 10.01.2023
     */
    dragElement(elmnt) {
      try {
        if (document.getElementById(elmnt.id + '-button')) {
          /* if present, the header is where you move the DIV from:*/
          document.getElementById(elmnt.id + '-button').onmousedown = this.dragMouseDown;
        } else {
          /* otherwise, move the DIV from anywhere inside the DIV:*/
          elmnt.onmousedown = this.dragMouseDown;
        }
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Hàm call đến lệnh kéo thả và xác định điểm bắt đầu
     * vcdoan 15.03.2023
     */
    startDrag(event) {
      try {
        if (this.isDragging) {
          this.isHovered = true;
          // event.preventDefault();
          this.startPosition.x = this.convertPxToVw(event.clientX);
          this.startPosition.y = this.convertPxToVh(event.clientY);
          this.convertLocationElementToXY(this.positionTransfrom);
          this.positionTransfrom.top = this.position.y;
          this.positionTransfrom.left = this.position.x;
          this.positionTransfrom.right = 'unset';
          this.positionTransfrom.bottom = 'unset';
          window.addEventListener('mousemove', this.drag);
          window.addEventListener('mouseup', this.stopDrag);
        }
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * Hàm xủ lý khi kéo thả
     * vcdoan 15.03.2023
     */
    drag(event) {
      try {
        event.preventDefault();
        if (this.isDragging) {
          const deltaX = this.convertPxToVw(event.clientX) - this.startPosition.x;
          const deltaY = this.convertPxToVh(event.clientY) - this.startPosition.y;

          let y = this.position.y + deltaY;
          if (y >= 0 && y <= 88) {
            this.position.y += deltaY;
            this.positionTransfrom.top = this.position.y;
            this.startPosition.y = this.convertPxToVh(event.clientY);
          }

          let x = this.position.x + deltaX;
          if (x >= 0 && x < 88) {
            this.position.x += deltaX;
            this.positionTransfrom.left = this.position.x;
            this.startPosition.x = this.convertPxToVw(event.clientX);
          }
          this.positionTransfrom.right = 'unset';
          this.positionTransfrom.bottom = 'unset';
        }
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * Hàm xử lý khi ngừng kéo thả và xác định lại điểm cuối kéo thả
     * vcdoan 15.03.2023
     */
    stopDrag(event) {
      try {
        this.isDragging = false;
        this.isHovered = false;

        event.preventDefault();

        if (this.position.y <= 100 * 0.05) {
          this.positionTransfrom.bottom = 'unset';
          this.positionTransfrom.top = 0;
        } else if (this.position.y >= 100 * 0.9) {
          this.positionTransfrom.top = 'unset';
          this.positionTransfrom.bottom = 0;
        }

        this.positionTransfrom.left = 'unset';
        this.positionTransfrom.right = 0;

        window.removeEventListener('mousemove', this.drag);
        window.removeEventListener('mouseup', this.stopDrag);
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Hàm thực hiện chuyển từ hiện tại của vật sang dạng trục x và y (left và top)
     * vcdoan 15.03.2023
     */
    convertLocationElementToXY(pos) {
      try {
        if (pos.top != 'unset') {
          this.position.y = pos.top;
        } else {
          this.position.y = 100 - pos.bottom - this.convertPxToVh(25);
        }

        if (pos.left != 'unset') {
          this.position.x = pos.left;
        } else {
          this.position.x = 100 - pos.right - this.convertPxToVw(25);
        }
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * Hàm chuyển đổi px sang vh
     * vcdoan 15.03.2023
     */
    convertPxToVh(px) {
      try {
        let height = window.innerHeight;
        if (height > 0) {
          return (px / height) * 100;
        } else {
          return 0;
        }
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * Hàm chuyển đổi px sang vw
     * vcdoan 15.03.2023
     */
    convertPxToVw(px) {
      try {
        let width = window.innerWidth;
        if (width > 0) {
          return (px / width) * 100;
        } else {
          return 0;
        }
      } catch (err) {
        console.log(err);
      }
    },

    handleMouseDown() {
      this.isDragging = true;
    },

    handleMouseUp() {
      this.isDragging = false;
      this.isHovered = false;
    },
  },
};
</script>

<style lang="scss">
.tool-feature-container {
  position: fixed;
  z-index: 999;
  width: 17px;
  height: 10px;

  .icon24.ic-doll-blue::before {
    visibility: hidden;
  }
}

.tool-feature-container.hovered,
.tool-feature-container:hover {
  position: fixed;
  z-index: 999;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  // background-color: red;
  // padding: 10px 5px 10px 10px;

  #live-chat-feature,
  #help-settlemen-quick,
  #ava-chat-bot,
  #misa-community-chat,
  #amis-support {
    margin-bottom: 10px;
  }

  &::before {
    z-index: -1;
    content: '';
    background-color: white;
    position: absolute;
    width: 48px;
    height: 102.5%;
    top: -7.5px;
    left: -5px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    box-shadow: rgb(0 0 0 / 10%) 0px 22px 40px 4px;
  }

  #help-settlemen-quick-container .icon24.ic-doll-blue::before {
    visibility: visible;
  }

  #help-settlemen-quick-container .ultility-btn-right {
    border-radius: 50%;
  }

  #new-feature-container .new-feature-button-wrapper .ultility-btn {
    background-image: url('@/assets/images/icons/ic_newfeature.svg');
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
    display: block;
  }

  #misa-ava-chat-bot-container .ic-ava-chat-bot {
    // background-image: url('@/assets/images/avaChatBot/sprites_va.svg');
    // background-repeat: no-repeat;
    border-radius: 50%;
    // background-position: -13px -11px;
  }
  .ic-ava-chat-bot {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .img-ava-icon {
    width: 36px;
    height: 32px;
    margin-top: 2px;
  }
  #livechat-button-container .icon {
    background-image: url('@/assets/images/icons/ic_Livechat.svg');
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  #amis-support-chat .icon {
    background-image: url('@/assets/images/logo-amis-support.svg');
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    width: 100%;
    height: 100%;
    transform: scale(1.2);
  }

  #amis-support-chat .live-chat-icon {
    width: 100%;
    height: 100%;
  }

  #amis-support-chat .quick-chat-bar .ultility-btn {
    background-color: unset;
    box-shadow: unset;
  }

  #amis-support-chat .unread-class {
    justify-content: center;
    align-items: center;
    display: flex;
  }

  #amis-support-chat .last-message {
    display: block;
  }

  #live-chat-feature .mi-live-chat-btn {
    background-size: contain;
  }

  #livechat-button-container .quick-chat-bar.right .live-chat-container {
    border-radius: 50%;
  }

  #amis-support-chat .quick-chat-bar.right .live-chat-container {
    border-radius: 50%;
  }

  .misa-community-container {
    display: block;
  }
}
</style>
